import React, { useState } from 'react';
import { auth } from '../config/firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';

import { sendPasswordResetEmail } from 'firebase/auth';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Auth = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
 
  const handleSignUp = async () => {
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      alert('User created successfully!');
      toast("user created")
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };

  const handleReset = async () => {
    try {
      await sendPasswordResetEmail(auth,email);
      alert('User created successfully!');
      toast("user created")
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };
 
 
  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert('User logged in successfully!');
    } catch (error) {
      console.error('Error logging in:', error);
    }
  };
 
  return (
    <div className='flex flex-col items-center h-screen w-screen justify-center'>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
      />
      <button onClick={handleSignUp}>Sign Up</button>
      <ToastContainer/>
      <button onClick={handleLogin}>Login</button>
      <button onClick={handleReset}>Reset password</button>
    </div>
  );
};
 
export default Auth;